module.exports = __webpack_public_path__ + "img/Paladin.ebbc0b7b.png";